console.log('preselect-variant.js loaded');

document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const shooterChoice = urlParams.get('shooters'); // "12" or "24"
  console.log('Query param shooters:', shooterChoice);
  if (!shooterChoice) return;

  // Grab the dropdown by its class
  const variantSelect = document.querySelector('select.select__select');
  if (!variantSelect) {
    console.log('Variant dropdown not found, exiting.');
    return;
  }
  console.log('Variant dropdown found:', variantSelect);

  // Loop through options to find the one matching shooterChoice
  let targetOption = null;
  Array.from(variantSelect.options).forEach(opt => {
    console.log('Option text:', opt.text);
    if (opt.text.includes(shooterChoice)) targetOption = opt;
  });

  if (!targetOption) {
    console.log('No matching option found.');
    return;
  }

  // Select it and trigger change event so Dawn updates price/images
  variantSelect.value = targetOption.value;
  variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  console.log('Variant selected:', targetOption.text);
});
